import { HiwItems } from "./types";

export const stepItems: HiwItems = [
  {
    question: "Who is responsible for maintenance of the home?",
    answer:
      "Keyzy or the owner will be responsible for any insurable costs such as storm damage or burst water pipes. We also make sure you have your gas and electrical safety certificates. You are responsible for wear and tear and day-to-day upkeep of the home.",
  },
  {
    question: "How long is my Keyzy agreement?",
    answer:
    "Your rental agreement (known as an assured periodic tenancy) is a rolling monthly agreement with no end date and your future buyback agreement is valid for 24 months from the day that your rental begins."      
  },
];
